<div class="d-flex gap-5">
    <div class="flex-grow-1 flex-shrink-1">
        <div class="d-block">
            <div class="button-bar">
                <app-button [iconName]="canvasMinimized ? 'arrows-maximize' : 'arrows-minimize'" (clickEvent)="canvasMinimized = !canvasMinimized; adjustParentHeightWithTimeout();"></app-button>
            </div>
            <div #parentDiv style="position: relative;">
                <canvas #backgroundCanvas
                        [style.max-width.px]="parentDiv.offsetWidth"
                        [style.max-height.vh]="canvasMinimized ? 75 : undefined"
                        style="position: absolute; top: 0; left: 0; z-index: 0;"></canvas>
                <canvas [style.max-width.px]="parentDiv.offsetWidth"
                        [style.max-height.vh]="canvasMinimized ? 75 : undefined"
                        style="position: absolute; top: 0; left: 0; z-index: 1;" #drawingCanvas
                        (mousedown)="mouseDown($event)"
                        (mousemove)="mouseMove($event)"
                        (mouseup)="mouseUp($event)"
                        (dblclick)="mouseDbClick($event)"
                ></canvas>
            </div>
        </div>
    </div>
    <div class="flex-shrink-0 flex-grow-0" [style.width.px]="!elementsCardCollapsed ? 200 : 30" style="width: 200px;">
        <div style="z-index: 3;position: relative;">
            <app-card [expandable]="true" [expanded]="true" (expandedEvent)="elementsCardCollapsed = !$event">
                <ng-container *ngIf="!elementsCardCollapsed">
                    <ng-content select="[elementsTmpl]"></ng-content>
                    <div>
                        <app-select-filter-v2 [parentFormGroup]="formGroup" parentFormControlName="optionValue" *ngIf="optionElements?.length > 0"
                                              [elements]="optionElements" (_onSingleSelectionChange)="optionSelected($event)"></app-select-filter-v2>
                        <app-button iconName="player-stop-filled" tooltip="Valider" *ngIf="isDrawing" (clickEvent)="stopDrawing(selectedDrawingItem)"></app-button>
                        <div class="d-flex justify-content-center">
                            <app-button iconName="zoom-in" (clickEvent)="zoom = zoom + 0.1; applyZoom()"></app-button>
                            <app-button iconName="zoom-out" (clickEvent)="zoom = zoom - 0.1; applyZoom()"></app-button>
                        </div>
                        <div>
                            <app-expandable-content [expanded]="drawingElementsExpanded">
                                <span title style="font-size: 0.7em;">Formes</span>
                                <div class="d-flex gap-5 flex-wrap">
                                    <app-button *ngFor="let el of drawingElements" [disabled]="isDrawing"
                                                [tooltip]="el.label"
                                                [iconName]="el.iconName"
                                                [fill]="el.value === selectedElementValue ? 'solid' : 'clear'"
                                                (clickEvent)="selectElement(el.value)"></app-button>
                                </div>
                                <div class="d-flex gap-5 flex-wrap" *ngIf="selectedDrawingElement as drawingElement">
                                    <app-button *ngFor="let el of drawingElement.subElements" [disabled]="isDrawing"
                                                [tooltip]="el.label"
                                                [iconName]="el.iconName"
                                                [fill]="el.value === selectedSubElementValue ? 'solid' : 'clear'"
                                                (clickEvent)="selectSubTypeElement(el.value)"></app-button>
                                </div>
                            </app-expandable-content>
                        </div>
                        <div>
                            <app-drawing-on-image-item-summary-field
                                    (selectedEvent)="selectItem($event)"
                                    [item]="item" *ngFor="let item of drawingData?.items" (deletedEvent)="deleteItem($event)"></app-drawing-on-image-item-summary-field>
                        </div>
                    </div>
                </ng-container>
            </app-card>

            <app-card title="Options" *ngIf="selectedDrawingItem" [expandable]="true" [expanded]="false">
                <div>
                    <app-drawing-on-image-item-summary-field
                            [selectable]="false"
                            [deletable]="false" [item]="selectedDrawingItem"></app-drawing-on-image-item-summary-field>
                </div>
                <div>
                    <app-input-text matTooltip="Nom" [parentFormGroup]="formGroup" parentFormControlName="label" (changedEvent)="refreshOptions()"></app-input-text>
                </div>
                <div class="d-flex gap-5">
                    <div class="flex-grow-1 flex-shrink-1">
                        <app-number-input matTooltip="Epaisseur" [parentFormGroup]="formGroup" parentFormControlName="thickness" [minValue]="1" (valueChangedEvent)="refreshOptions()"></app-number-input>
                    </div>
                    <div class="text-center d-block flex-grow-0 flex-shrink-0">
                        <app-button iconName="chevron-up" (clickEvent)="changeThickness(1)"></app-button>
                        <app-button iconName="chevron-down" (clickEvent)="changeThickness(-1)"></app-button>
                    </div>
                </div>
                <div class="d-flex gap-5">
                    <div class="flex-grow-1 flex-shrink-1">
                        <app-number-input matTooltip="Taille" [parentFormGroup]="formGroup" parentFormControlName="size" [minValue]="1" (valueChangedEvent)="refreshOptions()"></app-number-input>
                    </div>
                    <div class="text-center d-block flex-grow-0 flex-shrink-0">
                        <app-button iconName="chevron-up" (clickEvent)="changeSize(0.05)"></app-button>
                        <app-button iconName="chevron-down" (clickEvent)="changeSize(-0.05)"></app-button>
                    </div>
                </div>
                <div>
                    <app-input-color matTooltip="Couleur" [parentFormGroup]="formGroup" parentFormControlName="color" style="height: 30px; width: 100%;" (colorChangedEvent)="refreshOptions()"></app-input-color>
                </div>
            </app-card>
            <app-card title="Position" *ngIf="selectedDrawingItem" [expandable]="true" [expanded]="false">
                <div>
                    <app-select-filter-v2 [parentFormGroup]="formGroup" parentFormControlName="vertexIndexToMove" [elements]="optionVertexElements" matTooltip="Points à déplacer"></app-select-filter-v2>
                    <div class="text-center">
                        <app-button iconName="chevron-up" (clickEvent)="moveY(-1)"></app-button>
                    </div>
                    <div class="d-flex justify-content-center">
                        <app-button iconName="chevron-left" (clickEvent)="moveX(-1)"></app-button>
                        <app-button iconName="chevron-right" (clickEvent)="moveX(1)"></app-button>
                    </div>
                    <div class="text-center">
                        <app-button iconName="chevron-down" (clickEvent)="moveY(1)"></app-button>
                    </div>
                </div>
            </app-card>
        </div>
    </div>
</div>
